import styled from "styled-components";

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 200px;
  color: #333;
  font-size: 18px;
  font-weight: 500;
`; 

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const Columns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;

  & > div {
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  & > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 10px;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 10px;
`;

export const TimerContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: flex-end;
  gap: 10px;
  color: #2A2A2A;
`;

export const ListItem = styled.div`
  display: list-item;
  list-style: disc outside;
  margin-inline-start: 1.25rem;
  color: ${(props) => props.theme.colors.davysGrey};
  font-size: 14px;
`;

export const ErrorWrapper = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  padding: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.white};
  margin: 0 auto;
`;
